import React from "react";
import { SmartPayProfile } from "../../components/SmartPay/Profile";
import { useParams } from "react-router-dom";

export default function SmartPayProfilePage() {
  const { checkoutToken } = useParams();

  const handleError = async (data: string, error: any) => {
    console.log('Data: ' + data);
    console.log('Error: ' + error);
    let errorMsg;
    if ((typeof error === 'string' || error instanceof String ) && !error.startsWith('{')){
      errorMsg = error;
    } else {
      errorMsg = JSON.parse(error).message?.errorDetails?.gatewayDescription;
    }
    console.log('errorMsg: ' + errorMsg);
    window.location.href = `${process.env.REACT_APP_MOBILEAPP_ID}://profile_redirect?result=error&errorCode=${data}&errorMessage=${errorMsg}`;


  }

  const handleSuccess = async (data: any) => {
    window.location.href = `${process.env.REACT_APP_MOBILEAPP_ID}://profile_redirect?result=success&paymentProfileId=${data?.storedPaymentOptionReference}`;
  }

  const sdkUrl = process.env.REACT_APP_JPM_LIGHT_SDK_URL;

  return (
    <div>
      <SmartPayProfile
        checkoutToken={checkoutToken}
        onError={handleError}
        onSuccess={handleSuccess}
        sdkUrl={sdkUrl}
      />
    </div>
  )
}
